export default function Interior({data}) {
    return (
        <>
            <img className="img-ficha-ext-int" src={`${process.env.REACT_APP_UPLOAD_URL}${data.data.attributes.interior.featured_image.data.attributes.url}`} alt="" />
            <p>*Equipamiento varía según versión</p>
        </>
    )
}
